import { useCallback, useEffect, useState } from 'react';
import { idbStorage } from '@/utils/idbStorage';
import toast from 'react-hot-toast';

export function useLessonClipboard(key: string) {
  const [hasClipboard, setHasClipboard] = useState(false);

  useEffect(() => {
    let mounted = true;
    idbStorage
      .secureGetItem<any>(key)
      .then(v => {
        if (mounted) setHasClipboard(Boolean(v));
      })
      .catch(() => {
        if (mounted) setHasClipboard(false);
      });
    return () => {
      mounted = false;
    };
  }, [key]);

  const copy = useCallback(
    async (payload: Record<string, unknown>) => {
      try {
        await idbStorage.secureSetItem(key, payload);
        toast.success('Form copied');
        setHasClipboard(true);
      } catch {
        toast.error('Failed to copy form');
      }
    },
    [key]
  );

  const paste = useCallback(async () => {
    try {
      const stored = await idbStorage.secureGetItem<any>(key);
      if (!stored) {
        toast('Nothing to paste');
        return null;
      }
      toast.success('Form pasted');
      return stored as Record<string, unknown>;
    } catch {
      toast.error('Failed to paste form');
      return null;
    }
  }, [key]);

  return { hasClipboard, copy, paste } as const;
}
